import { render, staticRenderFns } from "./EditorCoordinate.vue?vue&type=template&id=6b3d8c68&"
import script from "./EditorCoordinate.vue?vue&type=script&lang=js&"
export * from "./EditorCoordinate.vue?vue&type=script&lang=js&"
import style0 from "./EditorCoordinate.vue?vue&type=style&index=0&id=6b3d8c68&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports